import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
    {
        _id: uuid(),
        title: "A Study of History",
        author: "Arnold J. Toynbee",
        description:
            "Arnold Toynbee's analysis of the rise and fall of civilizations has been acknowledged as one of the great achievements of twentieth-century scholarship. D.C. Somervell's abridgement of this monumental work is a great achievement in its own right.",
        price: 5000,
        categoryName: "history",
        rating: 2,
        discount: 20,
        image: "https://i.imgur.com/h6igzB5.jpg?1",
    },
    {
        _id: uuid(),
        title: "Plagues and Peoples",
        author: "William H. McNeill",
        description:
            "Plagues and Peoples was an immediate critical and popular success, offering a radically new interpretation of world history as seen through the extraordinary impact--political, demographic, ecological, and psychological--of disease on cultures. ",
        price: 1000,
        categoryName: "history",
        rating: 4,
        discount: 10,
        image: "https://i.imgur.com/lT8VqNY.jpg",
    },
    {
        _id: uuid(),
        title: "The Guns of August",
        author: "Barbara Tuchman",
        price: 6000,
        categoryName: "history",
        rating: 4,
        discount: 50,
        image: "https://i.imgur.com/tZAqj2T.jpg",
    },
    {
        _id: uuid(),
        title: "The Origin of Species",
        author: "Charles Darwin",
        price: 2000,
        categoryName: "science",
        rating: 1,
        discount: 40,
        image: "https://i.imgur.com/5a02oUs.jpg",
    },
    {
        _id: uuid(),
        title: "QED: The Strange Theory of Light and Matter",
        author: "Richard Feynman",
        price: 3000,
        categoryName: "science",
        rating: 4,
        discount: 10,
        image: "https://i.imgur.com/heTpJAx.jpg",
    },
    {
        _id: uuid(),
        title: "Ideas And Opinions",
        author: "Albert Einstein",
        price: 4000,
        categoryName: "science",
        rating: 3,
        discount: 20,
        image: "https://i.imgur.com/gcy4HTM.jpg",
    },
    {
        _id: uuid(),
        title: "Lives of a Cell",
        author: "Lewis Thomas",
        price: 1000,
        categoryName: "science",
        rating: 5,
        discount: 30,
        image: "https://i.imgur.com/fSVozFc.jpg",
    },
    {
        _id: uuid(),
        title: "The Structure of Scientific Revolutions",
        author: "Thomas Kuhn",
        price: 3000,
        categoryName: "science",
        rating: 3,
        discount: 10,
        image: "https://i.imgur.com/GHGKPNz.jpg",
    },
    {
        _id: uuid(),
        title: "In Search of Lost Time",
        author: "Marcel Proust",
        price: 1000,
        categoryName: "fiction",
        rating: 3.5,
        discount: 40,
        image: "https://i.imgur.com/q6E1gMe.jpg",
    },
    {
        _id: uuid(),
        title: "One Hundred Years of Solitude",
        author: "Gabriel Garcia Marquez",
        price: 3000,
        categoryName: "fiction",
        rating: 3.5,
        discount: 25,
        image: "https://i.imgur.com/drdlDsE.jpg",
    },
    {
        _id: uuid(),
        title: "War and Peace",
        author: "Leo Tolstoy",
        price: 1500,
        categoryName: "fiction",
        rating: 3,
        discount: 40,
        image: "https://i.imgur.com/7dQaZ8y.jpg",
    },
    {
        _id: uuid(),
        title: "To the Lighthouse",
        author: "Virginia Woolf",
        price: 5000,
        categoryName: "fiction",
        rating: 4.5,
        discount: 35,
        image: "https://i.imgur.com/VBjBP43.jpg",
    },
    {
        _id: uuid(),
        title: "The Odyssey",
        author: "Homer",
        price: 7000,
        categoryName: "fiction",
        rating: 3,
        discount: 25,
        image: "https://i.imgur.com/4SAuiPv.jpg",
    },
    {
        _id: uuid(),
        title: "Eloquent JavaScript, Third Edition",
        author: "Marijn Haverbeke",
        price: 4000,
        categoryName: "technology",
        rating: 4,
        discount: 10,
        image: "https://i.imgur.com/QwBrKDC.png",
    },
    {
        _id: uuid(),
        title: "Practical Modern JavaScript",
        author: "Nicolás Bevacqua",
        price: 500,
        categoryName: "technology",
        rating: 3,
        discount: 15,
        image: "https://i.imgur.com/GxSbFBv.jpg",
    },
    {
        _id: uuid(),
        title: "Understanding ECMAScript 6",
        author: "Nicholas C. Zakas",
        price: 2000,
        categoryName: "technology",
        rating: 5,
        discount: 50,
        image: "https://i.imgur.com/0oWeKKF.jpg",
    },
    {
        _id: uuid(),
        title: "Speaking JavaScript",
        author: "Axel Rauschmayer",
        price: 3000,
        categoryName: "technology",
        rating: 1,
        discount: 70,
        image: "https://i.imgur.com/enr2uwB.jpg",
    },
    {
        _id: uuid(),
        title: "Learning JavaScript Design Patterns",
        author: "Addy Osmani",
        price: 10000,
        categoryName: "technology",
        rating: 2.5,
        discount: 40,
        image: "https://i.imgur.com/bbtq5hF.jpg",
    },
    {
        _id: uuid(),
        title: "You Don't Know JS Yet",
        author: "Kyle Simpson",
        price: 8000,
        categoryName: "technology",
        rating: 3,
        discount: 20,
        image: "https://i.imgur.com/723VADF.png",
    },
];
